export default [
  //#region QUEJAS AGILIZA
  {
    path: "complaints-agiliza/parameters",
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/parameters"
      ),
    meta: {
      title: "Parametros",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Parametros",
          link: "/dashboard/complaints-agiliza/parameters",
        },
      ],
    },
  },
  {
    path: "complaints-agiliza/facilitators",
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/facilitators.vue"
      ),
    meta: {
      title: "Gestión de facilitadores",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de facilitadores",
          link: "/dashboard/complaints-agiliza/facilitators",
        },
      ],
    },
  },
  {
    path: "complaints-agiliza/management",
    name: "ComplaintsAgilizaManagement",
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/management.vue"
      ),
    meta: {
      title: "Quejas agiliza",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Quejas agiliza",
          link: "/dashboard/complaints-agiliza/management",
        },
      ],
    },
  },
  {
    path: "complaints-agiliza/details/",
    props: true,
    component: () =>
      import("@/views/dashboard/complaints/ComplaintDetails.vue"),
    meta: {
      title: "Detalle de queja Agiliza",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        { label: "Quejas Agiliza", name: "ComplaintsAgilizaManagement" },
        { label: "Ver detalle de queja agiliza" },
      ],
    },
  },
  {
    path: "complaints-agiliza/sessions",
    name: "SessionsAgiliza",
    props: true,
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/sessions.vue"
      ),
    meta: {
      title: "Gestión de sesiones de mediación",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de sesiones de mediación",
          link: "/dashboard/complaints-agiliza/sessions",
        },
      ],
    },
  },
  {
    path: "complaints-agiliza/sessions/outcome/:codigoQueja",
    name: "SessionsAgilizaOutcome",
    props: true,
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/outcome.vue"
      ),
    meta: {
      title: "Registro de cierre de la sesión de mediación",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de sesiones de mediación",
          link: "/dashboard/complaints-agiliza/sessions",
        },
        {
          label: "Registro de cierre de la sesión de mediación",
        },
      ],
    },
  },
  {
    path: "complaints-agiliza/sessions/:userFacilitatorId",
    name: "SessionsAgilizaFacilitator",
    props: true,
    component: () =>
      import(
        "@/feature/dashboard/complaints_agiliza/presentation/views/sessions.vue"
      ),
    meta: {
      title: "Gestión de sesiones de mediación",
      breadcrumb: [
        { label: "Inicio", link: "/" },
        {
          label: "Gestión de facilitadores",
          link: "/dashboard/complaints-agiliza/facilitators",
        },
        {
          label: "Gestión de sesiones de mediación",
        },
      ],
    },
  },
  //#endregion
];
